import * as React from 'react';

import { useSelector } from 'react-redux';
import Text from '../text';
import Link from '../link';
import Separator from '../atoms/separator';
import { Color } from '../../styles/colors';
import { isDesktop as isDesktopSelector } from '../../store/modules/header-module';
import AppBadges from './components/app-badges';
import SocialIcons from './components/social-icons';
import Logos from './components/logos';
import LegalLinks from './components/legal-links';
import SectionLinks from './components/section-links';
import AccessibilityLink from './components/accessibility-link';
import { SECTIONS } from './data/bh';
import { LEGAL_LINKS } from './data/legal-links';
import { LOGOS } from './data/logos';
type Props = {
  withTopBorder?: boolean;
};

const FooterBlinkHealth = ({ withTopBorder }: Props) => {
  const isDesktop = useSelector(isDesktopSelector);
  return (
    <section
      className="d-print-none py-sm-24 py-lg-60"
      style={{
        color: Color.tertiary100,
        borderTop: withTopBorder ? `1px solid ${Color.tertiary20}` : null,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-lg-6 d-sm-flex flex-sm-column">
            <div className="mb-sm-16">
              <Link to="/contact-us">
                <Text
                  id="footer-contact-us"
                  type="body2-blinkui"
                  color={Color.tertiary100}
                  user1stId="footer-contact-us"
                >
                  Contact Us
                </Text>
              </Link>
              {/* RR TODO: uncomment when ready */}
              {/* <DotSeparator />
              <a href="https://www.blinkhealth-support.com/hc/en-us" target="_blank" rel="noreferrer noopener">
               <Text id="footer-faqs" type="body2-blinkui" color={Color.tertiary100} user1stId="footer-faq-title">
                 FAQs
               </Text>
              </a> */}
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-3 col-lg-4 d-sm-flex flex-sm-column">
                <Text className="mb-sm-4" type="caption1-blinkui" user1stId="footer-contact-email">
                  info@blinkhealth.com
                </Text>
                <Text className="mb-sm-4" type="caption1-blinkui" user1stId="footer-contact-phone">
                  1 (844) 265-6444
                </Text>
              </div>
              <div className="col-sm-6 col-md-3 col-lg-4 d-sm-flex flex-sm-column" data-user1st-id="footer-faq-timings">
                <Text className="mb-sm-4" type="caption1-blinkui">
                  Mon–Fri: 8 am–10 pm ET
                </Text>
                <Text className="mb-sm-4" type="caption1-blinkui">
                  Sat–Sun: 9 am–7 pm ET
                </Text>
              </div>
            </div>
          </div>

          <div className="col-lg-6 d-sm-none d-lg-flex flex-sm-column">
            <Text className="mb-sm-24" type="caption1-blinkui" align="right" user1stId="footer-quote">
              Blink Health is driving down the cost of prescription drugs for everyone in America.
            </Text>
            <div className="d-sm-flex justify-content-lg-end align-items-sm-center" data-user1st-id="footer-social-app">
              <AppBadges className="mr-sm-24" height={40} />
              <SocialIcons />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <Separator className="my-sm-24 my-lg-36" />
          </div>
        </div>

        <React.Fragment>
          <div className="row">
            <SectionLinks items={SECTIONS} />
          </div>

          <Separator className="mt-sm-0 mb-sm-24 mb-lg-36" />
        </React.Fragment>

        <div className="row d-lg-none">
          <div className="col-sm-12 d-sm-flex flex-sm-column">
            <Text className="mb-sm-16" type="caption1-blinkui" user1stId="footer-quote">
              Blink Health is driving down the cost of prescription drugs for everyone in America.
            </Text>
            <Text className="mb-sm-16" type="title4-blinkui">
              Try the app now
            </Text>
            <div className="d-sm-flex align-items-sm-center mb-sm-n4" data-user1st-id="footer-social-app">
              <AppBadges height={48} />
            </div>
          </div>
        </div>

        <Separator className="d-lg-none my-sm-24 my-lg-36" />

        <div className="row">
          <div className="col-sm-12 col-lg-6 d-sm-flex flex-sm-column justify-content-sm-center">
            <LegalLinks items={LEGAL_LINKS} />

            {!isDesktop && <Logos className="mt-sm-24" items={LOGOS} />}

            <AccessibilityLink />

            <Text className="mt-sm-24" type="caption1-blinkui" user1stId="footer-address">
              Blink Health is NOT insurance. The discount plan organization is Blink Health Administration LLC, 1407
              Broadway, Suite 1910, New York, NY 10018, 1 (844) 265-6444, www.blinkhealth.com.
            </Text>
          </div>

          {isDesktop && <Logos className="col-lg-6 justify-content-lg-end mt-lg-0" items={LOGOS} />}
        </div>
      </div>
    </section>
  );
};

export default FooterBlinkHealth;
